// ============================================================================
// JAMB Learn Content — Government
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_GOVERNMENT_LEARN_SS1 } from '../../waec/learn/ss1/government';
import { WAEC_GOVERNMENT_LEARN_SS2 } from '../../waec/learn/ss2/government';
import { WAEC_GOVERNMENT_LEARN_SS3 } from '../../waec/learn/ss3/government';

export const JAMB_LEARN_GOVERNMENT = [
  ...WAEC_GOVERNMENT_LEARN_SS1,
  ...WAEC_GOVERNMENT_LEARN_SS2,
  ...WAEC_GOVERNMENT_LEARN_SS3,
];
